import axios from "axios";
import MainDashboard from "../components/layout/MainDashboard";
import {useState} from "react";
import DropdownMenuItem from "../components/layout/DropdownMenuItem";
import MainRoutes from "./MainRoutes";
import CornerInfo from "../components/layout/CornerInfo";

axios.interceptors.request.use(function (config) {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`
  }
  return config;
});

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    console.log(error.response.status)
    if (401 === error.response.status) {
      if(window.location.pathname.includes("activate") || window.location.pathname.includes("reset"))return Promise.reject(error);
      window.location = '/logout';
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  } else {
    return Promise.reject(error);
  }

});
const SecureApp = () => {
  const [isOpen, setIsOpen] = useState(false)
  const user = JSON.parse(localStorage.getItem('user'));
  const toggleMobile = () => {
    setIsOpen(!isOpen)
  }

  return(
    <MainDashboard
      isOpen={isOpen}
      toggleMobile={toggleMobile}
      topRight={
      <CornerInfo/>
      }
      items={
      <div>
        {(user.tipoUsuario === 1 || user.tipoUsuario === 2) && <DropdownMenuItem title={"Usuarios"} link={'/usuarios'} onClick={toggleMobile}/>}
        {(user.tipoUsuario === 1 || user.tipoUsuario === 2) && <DropdownMenuItem title={"Clientes"} link={'/clientes'} onClick={toggleMobile}/>}
        {(user.tipoUsuario === 1 || user.tipoUsuario === 2) && <DropdownMenuItem title={"Riesgos"} link={'/riesgos'} onClick={toggleMobile}/>}
        {(user.tipoUsuario === 1 || user.tipoUsuario === 2) && <DropdownMenuItem title={"Consejerias"} link={'/consejerias'} onClick={toggleMobile}/>}
        {(user.tipoUsuario === 1 || user.tipoUsuario === 2) && <DropdownMenuItem title={"Pdfs"} link={'/pdfs'} onClick={toggleMobile}/>}
        {(user.tipoUsuario !== 7) && <DropdownMenuItem title={"Horarios Atención"} link={'/horario'} onClick={toggleMobile}/>}
        {(user.tipoUsuario === 1 || user.tipoUsuario === 2) && <DropdownMenuItem title={"Fechas sin atención"} link={'/sin-atencion'} onClick={toggleMobile}/>}
        {(user.tipoUsuario === 1 || user.tipoUsuario === 2) && <DropdownMenuItem title={"Grupos etarios"} link={'/rango-edad'} onClick={toggleMobile}/>}
        {(user.tipoUsuario === 1 || user.tipoUsuario === 2) && <DropdownMenuItem title={"Productos"} link={'/productos'} onClick={toggleMobile}/>}
        {(user.tipoUsuario === 1 || user.tipoUsuario === 2) && <DropdownMenuItem title={"Categorias"} link={'/categoria'} onClick={toggleMobile}/>}
        {(user.tipoUsuario === 1 || user.tipoUsuario === 2) && <DropdownMenuItem title={"Pedidos"} link={'/pedidos'} onClick={toggleMobile}/>}
        {(user.tipoUsuario !== 7) && <DropdownMenuItem title={"Citas consejeria"} link={'/citas'} onClick={toggleMobile}/>}
        {(user.tipoUsuario === 1 || user.tipoUsuario === 2) && <DropdownMenuItem title={"Ingresos"} link={'/ingresos'} onClick={toggleMobile}/>}
      </div>
      }
    >
      <MainRoutes/>
    </MainDashboard>
  )
}

export default SecureApp;
